import React from 'react';
import { FaLinkedin, FaPhoneAlt,FaWhatsapp,FaInstagram} from 'react-icons/fa';

const SocialMediaIcons = () => {
  return (
    <div className="social-media-icons">
      {/* LinkedIn icon */}
      <a style={{color:"red"}} href="https://www.instagram.com/smartstonemarbles/" target="_blank" rel="noopener noreferrer">
        <FaLinkedin className="icon linkedin" />
      </a>

      {/* Instagram icon */}
      <a href="https://www.instagram.com/smartstonemarbles/" target="_blank" rel="noopener noreferrer">
        <FaInstagram className="icon linkedin" />
      </a>

      {/* Phone call icon */}
      <a href="tel:+971566605705">
        <FaPhoneAlt className="icon phone" />
      </a>

    

      {/* WhatsApp icon */}
      <a href="https://wa.me/+971566605705" target="_blank" rel="noopener noreferrer">
        <FaWhatsapp className="icon whatsapp" />
      </a>

    
    </div>
  );
};

export default SocialMediaIcons;